import { Form } from "react-bootstrap";
import CurrencyCustomInput from "../utils/CurrencyCustomInput";

// Extracted FilterArea component
export function FilterArea({ filterParams, setFilterParams }) {
  return (
    <Form>
      <div className="d-flex">
        <Form.Group className="mx-3">
          <CurrencyCustomInput
            name="minPrice"
            value={filterParams.minPrice}
            onValueChange={(value) => {
              setFilterParams((prev) => ({
                ...prev,
                page: 1,
                minPrice: value,
              }));
            }}
            placeholder="Minimum"
          />
        </Form.Group>

        <Form.Group>
          <CurrencyCustomInput
            name="maxPrice"
            value={filterParams.maxPrice}
            onValueChange={(value) => {
              setFilterParams((prev) => ({
                ...prev,
                page: 1,
                maxPrice: value,
              }));
            }}
            placeholder="Maximum"
          />
        </Form.Group>
      </div>
    </Form>
  );
}
